import React from "react";
import {FormFieldInput} from "ui-components-rollup/dist/Forms";
import styles from "./Form.module.scss";

export default ({ onFormSubmit, handleFormSubmit, handleFormChange, formState, formErrors, submissionAttempted }) => {
    return (
        <form className={styles["form"]} onSubmit={handleFormSubmit(onFormSubmit)}>
            <FormFieldInput
                type="text"
                name="name"
                label="Working Environment Name"
                value={formState.name}
                onChange={handleFormChange}
                charCount={true}
                maxChars={256}
                errorMessage={submissionAttempted && formErrors.name}
            />
            <FormFieldInput
                type="text"
                name="clientId"
                label="Application (client) ID"
                value={formState.clientId}
                onChange={handleFormChange}
                errorMessage={submissionAttempted && formErrors.clientId}
            />
            <FormFieldInput
                type="password"
                name="clientSecret"
                label="Client Secret"
                value={formState.clientSecret}
                onChange={handleFormChange}
                errorMessage={submissionAttempted && formErrors.clientSecret}
            />
            <FormFieldInput
                type="text"
                name="tenantId"
                label="Directory (tenant) ID"
                value={formState.tenantId}
                onChange={handleFormChange}
                errorMessage={submissionAttempted && formErrors.tenantId}
            />
        </form>
    );
};
